











 






















const node = {
  "kind": "InlineDataFragment",
  "name": "useGotoStageId_meeting"
};

(node ).hash = "fa967e7e0be11858e7c90dee28075950";

export default node;
